import React from "react";

import { Box, Typography, Button } from "@material-ui/core";

import MailOutlineIcon from "@material-ui/icons/MailOutline";
import useStyles from "./styles";

export const ConfirmFinish = () => {
  const classes = useStyles();

  const handleRedirectLogin = () => window.location.assign(process.env.REACT_APP_TROCAR_APP_URL)

  return (
    <Box className={classes.confirmContainer}>
      <Box className={classes.alignCenterContainer}>
        <Box className={classes.mailIcon}>
          <MailOutlineIcon />
        </Box>
      </Box>
      <Typography variant="h5">
        Enviamos um e-mail para você completar o seu cadastro!
      </Typography>
      <Box>
        <Typography className={classes.infoText}>
          Em alguns instantes você receberá um e-mail com instruções para a
          criação da sua senha. Após completar o seu cadastro, será feita uma
          análise de segurança para liberar o seu login.
        </Typography>
      </Box>
      <Box className={classes.alignCenterContainer}>
        <Button
          variant="contained"
          disableElevation
          color="primary"
          className={classes.confirmBtn}
          onClick={handleRedirectLogin}
        >
          Ok, entendi
        </Button>
      </Box>

      <Typography className={classes.questions}>
        Caso tenha dúvidas na ativação da sua conta,{" "}
        <a href="https://www.cargill.com/">clique aqui!</a>
      </Typography>
    </Box>
  );
};
